import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import {
  FaChartLine,
  FaCalendarCheck,
  FaClock,
  FaSignOutAlt,
  FaBlog,
  FaStar,
  FaListUl,
  FaEdit,
  FaUserCircle,
  FaImage,
  FaAddressBook,
} from 'react-icons/fa';
import './AdminLayout.css';
import './AdminForms.css';

const AdminLayout = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    navigate('/admin/login');
  };

  return (
    <div className="admin-layout" dir="rtl">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-header">
          <h2>لوحة الإدارة</h2>
          <span className="admin-subtitle">د. نهى الحازمي</span>
        </div>
        <nav className="admin-nav">
          <NavLink to="/admin" end className={({ isActive }) => (isActive ? 'active' : '')}>
            <FaChartLine /> لوحة التحكم
          </NavLink>
          <NavLink to="/admin/bookings" className={({ isActive }) => (isActive ? 'active' : '')}>
            <FaCalendarCheck /> الحجوزات
          </NavLink>
          <NavLink to="/admin/contacts" className={({ isActive }) => (isActive ? 'active' : '')}>
            <FaAddressBook /> جهات الاتصال
          </NavLink>
          <NavLink to="/admin/services" className={({ isActive }) => (isActive ? 'active' : '')}>
            <FaListUl /> الخدمات
          </NavLink>
          <NavLink
            to="/admin/services-section"
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            <FaEdit /> واجهة الخدمات
          </NavLink>
          <NavLink to="/admin/time-slots" className={({ isActive }) => (isActive ? 'active' : '')}>
            <FaClock /> جدول الأوقات
          </NavLink>
          <NavLink to="/admin/availability" className={({ isActive }) => (isActive ? 'active' : '')}>
            <FaClock /> الأوقات
          </NavLink>
          <NavLink to="/admin/blog" className={({ isActive }) => (isActive ? 'active' : '')}>
            <FaBlog /> المدونة
          </NavLink>
          <NavLink to="/admin/hero" className={({ isActive }) => (isActive ? 'active' : '')}>
            <FaEdit /> الهيرو
          </NavLink>
          <NavLink to="/admin/meetme" className={({ isActive }) => (isActive ? 'active' : '')}>
            <FaUserCircle /> من أنا؟
          </NavLink>
          <NavLink to="/admin/solutions" className={({ isActive }) => (isActive ? 'active' : '')}>
            <FaEdit /> الحلول
          </NavLink>
          <NavLink to="/admin/gallery" className={({ isActive }) => (isActive ? 'active' : '')}>
            <FaImage /> المعرض
          </NavLink>
          <NavLink to="/admin/community" className={({ isActive }) => (isActive ? 'active' : '')}>
            <FaUserCircle /> المجتمع
          </NavLink>
          <NavLink to="/admin/about" className={({ isActive }) => (isActive ? 'active' : '')}>
            <FaUserCircle /> صفحة من أنا 
          </NavLink>
          <NavLink to="/admin/quote" className={({ isActive }) => (isActive ? 'active' : '')}>
            <FaEdit /> الاقتباس
          </NavLink>
          <NavLink to="/admin/products" className={({ isActive }) => (isActive ? 'active' : '')}>
            <FaListUl /> المنتجات
          </NavLink>
          <NavLink to="/admin/reviews" className={({ isActive }) => (isActive ? 'active' : '')}>
            <FaStar /> التقييمات
          </NavLink>
          <NavLink to="/admin/faq" className={({ isActive }) => (isActive ? 'active' : '')}>
            <FaEdit /> الأسئلة الشائعة
          </NavLink>
        </nav>
        <button className="admin-logout-btn" onClick={handleLogout}>
          <FaSignOutAlt /> تسجيل الخروج
        </button>
      </aside>
      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
